export default __webpack_public_path__ + "c51201541ac40f25f1e391c3d8637e89.png";